import React from 'react';

function PmsDocs() {
    const iframeSrc = `https://pms-manifests-ensoconnect.s3.amazonaws.com/viewer/index.html?t=${Date.now()}`;

    return (
        <div style={{ overflow: 'hidden', height: 'calc(100vh - 64px)' }}>
            <iframe
                src={iframeSrc}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block',
                }}
                title="PMS Docs"
            />
        </div>
    );
}

export default PmsDocs;
